export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#02060D] border-t border-white/5 pt-24 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="font-serif text-white text-5xl sm:text-7xl lg:text-9xl tracking-tighter leading-[0.9] mb-16">
          Count<span className="italic text-[#D1B677]">Goa</span>.
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 pb-16 border-b border-white/5">
          <div className="md:col-span-5">
            <p className="font-serif text-white text-xl lg:text-2xl leading-snug mb-4">
              Connecting Goa to the World for{" "}
              <span className="italic text-[#D1B677]">Global Business Opportunities.</span>
            </p>
            <p className="text-sm text-[#A1AEBF]/70 leading-relaxed max-w-sm">
              CountGoa — a trust-first premium ecosystem powering Goa's bridge to
              international capital, partnership and trade.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D1B677] mb-4">
              Explore
            </div>
            <ul className="space-y-2 text-sm text-[#A1AEBF]">
              <li><a href="#opportunities" className="hover:text-white transition-colors">Opportunities</a></li>
              <li><a href="#investors" className="hover:text-white transition-colors">Investors</a></li>
              <li><a href="#businesses" className="hover:text-white transition-colors">Goa Businesses</a></li>
              <li><a href="#showcase" className="hover:text-white transition-colors">Showcase</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D1B677] mb-4">
              Pathways
            </div>
            <ul className="space-y-2 text-sm text-[#A1AEBF]">
              <li>Invest</li>
              <li>Partner</li>
              <li>Trade</li>
              <li>Expand</li>
              <li>Collaborate</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#D1B677] mb-4">
              Begin
            </div>
            <p className="text-sm text-[#A1AEBF] mb-4 leading-relaxed">
              Goa-based business? Register FREE today.
            </p>
            <a
              href="#register"
              data-testid="footer-register-btn"
              className="inline-block text-sm px-5 py-2.5 border border-[#D1B677] text-[#D1B677] hover:bg-[#D1B677] hover:text-[#02060D] transition-all"
            >
              Register Free
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#A1AEBF]/60">
          <div>© {new Date().getFullYear()} CountGoa. All rights reserved.</div>
          <div className="tracking-[0.2em] uppercase">
            Powering Goa · Connecting the World
          </div>
        </div>

        <div
          data-testid="footer-attribution"
          className="mt-10 pt-8 border-t border-white/5 text-center"
        >
          <div className="font-serif text-white text-lg sm:text-xl leading-snug">
            <span className="italic text-[#D1B677]">the Visibility Initiative</span>
          </div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#A1AEBF]/70 mt-3">
            Registered under the MSME of India
          </div>
          <div className="text-xs text-[#A1AEBF]/60 mt-1">
            Global Marketing &amp; Consultancy Agency
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
